// A FOTO DO ARTISTA É UMA SÓ EM TODA A PLATAFORMA (pedido do Lucas, 30/10/2026): a que ele escolheu
// no Perfil (do computador ou do Branding), guardada em `artists.foto_url` pelo gatilho; sem
// escolha, a do Spotify. A casca, o Início, Seus perfis, o CRM, o Branding, o Material, as Redes, o
// cronograma e o PDF do diagnóstico leem daqui, e nenhuma tela lê a do Spotify sozinha.

type ComFoto = {
  foto_url?: string | null;
  content?: { spotifyProfile?: { image?: string | null } | null } | null;
} | null | undefined;

export const fotoDoArtista = (artista: ComFoto): string | null =>
  artista?.foto_url || artista?.content?.spotifyProfile?.image || null;
